module.exports = __webpack_public_path__ + "static/media/twilioPhoneAllowed.8a5f6a17.svg";